import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Row, message, Form } from 'antd';
import EditForm from '../../../../components/EditForm';
import { toDate } from '../../../../helpers/utils';
import { EditorContext } from '../../EditorContext/editorContext';
import {
  ButtonCancelar,
  ButtonSalvar,
  DivButtons,
  DivItems,
} from '../../../../components/EditForm/styles';
import { getEstadosList } from '../../../../services/estado';
import { foneMask } from '../../../../helpers/helpersEditForm';
import {
  getEnderecoForm,
  enviarDadosPessoa,
  getPayloadPFPJ,
  getRNTRCForm,
} from '../Helpers/helpers';

export default function InfoProprietarioCavaloEdicao({
  dadosProp,
  setReadOnly,
  carregarSolicitacaoAtual,
  setSpinning,
}) {
  const { setLockButton } = useContext(EditorContext);
  const [form] = Form.useForm();

  const [listUF, setListUF] = useState([]);

  const initialState = async () => {
    try {
      const response = await getEstadosList();
      setListUF(response.items);
    } catch (error) {}
  };

  useEffect(() => {
    initialState();
  }, []);

  const salvarEdicao = async form => {
    if (form.cnpj.includes('_')) {
      return message.error('CNPJ incompleto.');
    }

    setLockButton(false);
    setReadOnly(true);

    const payload = getPayloadPFPJ(dadosProp, form, true);

    return enviarDadosPessoa(
      setSpinning,
      carregarSolicitacaoAtual,
      setReadOnly,
      payload
    );
  };

  let propPF = [
    {
      label: 'CPF',
      nome: 'cpfCnpj',
      width: '32%',
      initialValue:
        dadosProp?.pessoaFisicaCadastro?.cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4'
        ) || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Nome',
      nome: 'nome',
      width: '98.7%',
      initialValue: dadosProp?.pessoaFisicaCadastro?.nome || null,
    },
    {
      label: 'Contato',
      nome: 'telefone',
      width: '32%',
      initialValue: dadosProp?.telefone || null,
      onChange: e => foneMask(e.target.value, form, 'telefone'),
    },
    {
      label: 'Nome da Mãe',
      nome: 'nomeMae',
      width: '32%',
      initialValue: dadosProp?.pessoaFisicaCadastro?.nomeMae || null,
    },

    {
      label: 'Nº id. do trabalhador (NIT)',
      nome: 'numeroPIS',
      width: '32%',
      initialValue: dadosProp.pessoaFisicaCadastro?.numeroPIS || null,
    },
  ];

  propPF = getRNTRCForm(form, propPF, dadosProp?.proprietarioCadastro);

  propPF = getEnderecoForm(propPF, dadosProp?.dadosEndereco, listUF);

  const propPJ = [
    {
      label: 'Nome Fantasia',
      nome: 'nomeFantasia',
      width: '98.7%',
      initialValue: dadosProp?.pessoaJuridicaCadastro?.nomeFantasia || null,
    },
    {
      label: 'Razão Social',
      nome: 'razaoSocial',
      width: '98.7%',
      initialValue: dadosProp?.pessoaJuridicaCadastro?.razaoSocial || null,
    },
  ];

  propPF = getRNTRCForm(form, propPF, dadosProp?.proprietarioCadastro);
  propPF = getEnderecoForm(propPF, dadosProp?.dadosEndereco, listUF);

  return (
    <Row
      justify="space-between"
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        marginTop: 32,
      }}
    >
      <Form form={form} layout="vertical" onFinish={form => salvarEdicao(form)}>
        {dadosProp?.pessoaFisicaCadastro?.cpf ? (
          <DivItems>
            {propPF.map(item => (
              <EditForm key={item.nome} item={item} form={form} />
            ))}
          </DivItems>
        ) : (
          <DivItems>
            {propPJ.map(item => (
              <EditForm key={item.nome} item={item} form={form} />
            ))}
          </DivItems>
        )}

        <DivButtons>
          <Form.Item>
            <ButtonCancelar onClick={() => setReadOnly(true)}>
              Cancelar
            </ButtonCancelar>
          </Form.Item>
          <Form.Item>
            <ButtonSalvar>Salvar</ButtonSalvar>
          </Form.Item>
        </DivButtons>
      </Form>
    </Row>
  );
}
